import { Col, Row } from '@paypalcorp/pp-react';
import cx from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { SDK_FLOW_SLUG } from '../../../../constants/sdk';
import AdvancedPreviewWrapper from '../../../Advanced/PreviewWrapper';
import FastlanePreviewWrapper from '../../../Fastlane/PreviewWrapper';
import CodeWrapper from '../../CodeWrapper';
import PreviewWrapper from '../index';
import styles from './ExpandablePreview.module.less';

const PreviewSwitch = () => {
  const { product } = useParams();

  switch (product) {
    case SDK_FLOW_SLUG.FASTLANE:
      return <FastlanePreviewWrapper />;
    case SDK_FLOW_SLUG.ADVANCED:
      return <AdvancedPreviewWrapper />;
    default:
      return <PreviewWrapper />;
  }
};

const ExpandablePreview = ({ expandedMode, prevScroll }) => {
  useEffect(() => {
    if (expandedMode) {
      window.scrollTo({ top: 0 });
    } else {
      if (!prevScroll) {
        return;
      }
      window.scrollTo({ top: prevScroll });
    }
  }, [expandedMode]);

  return (
    <Row
      className={cx([styles.row_wrapper, { [styles.row_wrapper__expanded]: expandedMode }])}
      noGutters
    >
      <Col
        xs={expandedMode ? 5 : 12}
        className={cx({ [styles.preview_col__expanded]: expandedMode })}
      >
        <PreviewSwitch />
      </Col>
      {expandedMode && (
        <Col xs={7} className={styles.code_col__expanded}>
          <CodeWrapper />
        </Col>
      )}
    </Row>
  );
};

ExpandablePreview.propTypes = {
  expandedMode: PropTypes.bool.isRequired,
  prevScroll: PropTypes.number
};

ExpandablePreview.defaultProps = {
  prevScroll: null
};

export default ExpandablePreview;
